/** @format */

import axios from "axios";
import {
	IContributionCyclePayload,
	IContributionPayload,
} from "../../utility/types/contributionType";
import { API_BASE_URL } from "../../axiosConfig/apiUrl";

export const submitCreateContribution = async (
	payload: IContributionPayload,
) => {
	try {
		const response = await axios.post(
			`${API_BASE_URL}/contribute`,
			{ payload },
			{ withCredentials: true },
		);

		return response.data;
	} catch (error: any) {
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	}
};

export interface IMissedContributionPayload {
	memberId: string;
	unionId: string;
	paymentMethodId: string;
	missedDates: string[];
}

export const submitPayMissedContributions = async (
	payload: IMissedContributionPayload,
) => {
	try {
		const response = await axios.post(
			`${API_BASE_URL}/contribute/missed`,
			{ payload },
			{ withCredentials: true },
		);

		return response.data;
	} catch (error: any) {
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	}
};

export const submitGetContributionStatus = async (
	unionId: string,
	memberId: string,
) => {
	try {
		const response = await axios.get(
			`${API_BASE_URL}/contribute/status?unionId=${unionId}&memberId=${memberId}`,

			{ withCredentials: true },
		);

		return response.data;
	} catch (error: any) {
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	}
};

export const submitStartCycle = async (
	unionId: string,
	payload: IContributionCyclePayload,
) => {
	try {
		const response = await axios.post(
			`${API_BASE_URL}/contribute/start-cycle/circle/${unionId}`,
			{ payload },
			{ withCredentials: true },
		);

		return response.data;
	} catch (error: any) {
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	}
};

export const submitEndCycle = async (cycleId: string, unionId: string) => {
	try {
		const response = await axios.post(
			`${API_BASE_URL}/contribute/end-cycle/${cycleId}/circle/${unionId}`,
			{},
			{ withCredentials: true },
		);

		return response.data;
	} catch (error: any) {
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	}
};

export const submitGetCurrentCycleOfCircle = async (unionId: string) => {
	try {
		const response = await axios.get(
			`${API_BASE_URL}/contribute/cycle/circle/${unionId}`,
			{ withCredentials: true },
		);
		return response.data;
	} catch (error: any) {
		// Log the full error.response object
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	} finally {
	}
};

export const submitGetCurrentCycleById = async (
	unionId: string,
	cycleId: string,
) => {
	try {
		const response = await axios.get(
			`${API_BASE_URL}/contribute/circle/${unionId}/cycle/${cycleId}/circle-cycle-contribution`,
			{ withCredentials: true },
		);
		return response.data;
	} catch (error: any) {
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	}
};

export const submitGetMembersContributionStatusOfCircleCycle = async (
	unionId: string,
	cycleId: string,
) => {
	try {
		const response = await axios.get(
			`${API_BASE_URL}/contribute/circle/${unionId}/cycle/${cycleId}/members-status`,
			{ withCredentials: true },
		);
		return response.data;
	} catch (error: any) {
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	}
};

export const submitFetchContributionCycleById = async (cycleId: string) => {
	if (!cycleId) {
		throw new Error("Cycle ID is required");
	}
	try {
		const response = await axios.get(
			`${API_BASE_URL}/contribution-cycle/${cycleId}`,
			{ withCredentials: true },
		);
		return response.data;
	} catch (error: any) {
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	}
};

export const submitGetContributionChartData = async (
	unionId: string,
	params: any,
) => {
	try {
		const response = await axios.get(
			`${API_BASE_URL}/contribute/chart-data/${unionId}?${params}`,
			{ withCredentials: true },
		);

		return response.data;
	} catch (error: any) {
		const errorMessage =
			(error.response &&
				(error.response.data.message || error.response.data)) ||
			"Unknown Error Occurred While Making Request";
		throw new Error(errorMessage);
	}
};
